// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__11hLc","col":"styles_col__3o3lK","fulfillmentStatus":"styles_fulfillmentStatus__2wcas","emailCol":"styles_emailCol__2L68a"};